import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";
import { cx } from "../internal/cx.js";

/**
 * Icon + label + description layout for command items.
 *
 * Variants:
 *   - `default` — standard command-palette item body.
 */
const richCommandItemVariants = cva("cw-v2-rich-command-item", {
  variants: {
    variant: {
      default: "cw-v2-rich-command-item--default",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface RichCommandItemProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof richCommandItemVariants> {
  icon?: React.ReactNode;
  label: React.ReactNode;
  description?: React.ReactNode;
}

export const RichCommandItem = React.forwardRef<HTMLDivElement, RichCommandItemProps>(
  function RichCommandItem({ className, description, icon, label, variant, ...props }, ref) {
    return (
      <div ref={ref} className={cx(richCommandItemVariants({ variant }), className)} {...props}>
        {icon ? (
          <span aria-hidden className="cw-v2-rich-command-item__icon">
            {icon}
          </span>
        ) : null}
        <span className="cw-v2-rich-command-item__content">
          <span className="cw-v2-rich-command-item__label">{label}</span>
          {description ? (
            <span className="cw-v2-rich-command-item__description">{description}</span>
          ) : null}
        </span>
      </div>
    );
  },
);
RichCommandItem.displayName = "RichCommandItem";
